/**
 * Shared Swiper init for News block
 */
export const initSwiper = (el) => {
    console.log("call init swiper")
    console.log(el);
    console.log(el.swiper);

    if (!el || el.swiper) return; // prevent double init

    console.log("init swiper");


    new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 20,
        pagination: {
            el: '.swiper-pagination-news',
            clickable: true,
        },
        centeredSlides: true,
        breakpoints: {
            834: {
                slidesPerView: 2,
                spaceBetween: 20,
                grid: { rows: 2 },
                centeredSlides: false,
            },
            1200: {
                spaceBetween: 30,
                slidesPerView: 2,
                grid: { rows: 2 },
                centeredSlides: false,
            },
        },
    });
};


export const destroySwiper = (el) => {
    if (el.swiper) {
        el.swiper.destroy(true, true);
    }
};